
import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs';
import { ApiService } from '../../../../core/services/api.service';
import { ApiEndPoints, ApiRoot } from '../../../../shared/constants/api-endpoints';
import { BgcMemberDetailRequest, BgcMemberDetailResponse, BgcMemberDetail } from '../../../../shared/models/services-request/bgc-member-detail.model';
import { SkeletonLoaderComponent } from '../../../../shared/components/skeleton-loader/skeleton-loader.component';
import { ValidationMessageComponent } from '../../../../shared/components/validation-message/validation-message.component';
import { Router, RouterLink, RouterLinkActive, RouterModule, RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { SharedService } from '../../../../shared/services/shared.service';
import { DocumentServiceType, FieldValue } from '../../../../shared/constants/services.enum';
import { DocumentItem, FolderResponse } from '../../../../shared/models/documents-response.model';

@Component({
  standalone:true,
  selector: 'app-business-group',
  imports: [RouterModule, RouterOutlet, TranslateModule, RouterLink, RouterLinkActive, ButtonComponent, SkeletonLoaderComponent, ValidationMessageComponent],
  templateUrl: './business-group.component.html',
  styleUrl: './business-group.component.scss'
})
export class BusinessGroupComponent implements OnInit {
  memberDetail: BgcMemberDetail | null = null;
  loading = false;
  loadFailed = false;
  userCSN = '';
  bgcDocuments: DocumentItem[] = [];
  memberDocumentFolder: FolderResponse | null = null;
  documentsLoading = false;
  documentsLoadFailed = false;
  lang:string='en';
  
  constructor(
    private router: Router,
    private api: ApiService,
    private destroyRef: DestroyRef,
    private translate: TranslateService,
    private sharedService: SharedService
  ){
     this.lang = this.sharedService.getCurrentLang() || 'en';
  }
  manager:any={
    initials: 'MA',
    name: 'Maithaa AlShuweihi',
    title: 'Relationship Manager',
    email: 'maithaa.alshuweihi@dcc.com',
    workingHours: '8:00 am to 4:00 pm GST'
  }
  tabs = [
    { route: 'about',              label: 'BUSINESS_GROUP.MEMBERS.TAB_ABOUT' },
    { route: 'members',            label: 'BUSINESS_GROUP.MEMBERS.TAB_MEMBERS' },
    { route: 'documents',          label: 'BUSINESS_GROUP.MEMBERS.TAB_DOCUMENTS' }
    // { route: 'challenges-report',  label: 'BUSINESS_GROUP.MEMBERS.TAB_CHALLENGES_REPORT' },
    // { route: 'manage-users',       label: 'BUSINESS_GROUP.MEMBERS.TAB_MANAGE_USERS' }
    // { route: 'manage-users',       label: 'BUSINESS_GROUP.MEMBERS.TAB_MANAGE_USERS' }
  ];

  // This method is used to active mobile route
  get activeMobileRoute(): string {
    return this.router.url.split('/').pop() ?? 'about';
  }

  /** navigate when user picks an option on mobile */
  goTo(route: any): void {
    this.router.navigate(['business-group', route.value]);
  }

    get groupName(): string {
    const detail = this.memberDetail;
    if (!detail) return '-';
    const keys = this.translate.currentLang === 'ar'
      ? ['DC Name Arabic', 'DC Member Name(Arabic)', 'DC Name English', 'DC Member Name(English)', 'Name']
      : ['DC Name English', 'DC Member Name(English)', 'Name'];
    for (const key of keys) {
      const value = detail[key];
      if (typeof value === 'string' && value.trim()) return value;
    }
    return '-';
  }

  ngOnInit(): void {
    this.getBGCDetail();
  }

  getBGCDetail(): void {
    this.loading = true;
    this.loadFailed = false;
    this.memberDetail = null;
    this.userCSN = '';
    this.bgcDocuments = [];
    this.memberDocumentFolder = null;
    this.documentsLoadFailed = false;
    const request = new BgcMemberDetailRequest();
    request.body['Account Id']='1-5V4MQE5';
    request.body['CSN']='';
    request.body.DCLanguage = this.lang === 'ar' ? 'ARA' : 'ENU';
    request.body['DC Channel'] = this.lang === 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN;
    
    request.body['DC Method']='Business Group Detail Page';
    this.api.post<BgcMemberDetailRequest, BgcMemberDetailResponse>(
      ApiRoot.CRM_BGBC, ApiEndPoints.GET_BGC_MEMBER_DETAILS, request
    ).pipe(
      takeUntilDestroyed(this.destroyRef),
      finalize(() => this.loading = false)
    ).subscribe({
      next: response => {
        const detail = response?.SiebelMessage?.['DC BGC Member Details'];
        if (response?.['Error Code'] || response?.['Error Message'] || !detail) {
          this.loadFailed = true;
          return;
        }
        this.memberDetail = detail;
        this.userCSN = String(detail['CSN'] ?? '').trim();
        this.getBGCDocuments();
      },
      error: () => this.loadFailed = true
    });
  }

  getBGCDocuments(): void {
    this.userCSN = "39587"
    if (!this.userCSN || this.documentsLoading) return;
    this.documentsLoading = true;
    this.documentsLoadFailed = false;
    this.bgcDocuments = [];
    this.memberDocumentFolder = null;
    this.sharedService.getDocuments('', DocumentServiceType.MEMBERSHIP_WALLET, false, {
      memNumber: this.userCSN
    }).pipe(
      takeUntilDestroyed(this.destroyRef),
      finalize(() => this.documentsLoading = false)
    ).subscribe({
      next: response => {
        if (!response?.success) {
          this.documentsLoadFailed = true;
          return;
        }
        const folder: FolderResponse = response.data ?? response;
        this.memberDocumentFolder = folder;
        this.bgcDocuments = folder.documents ?? [];
      },
      error: () => this.documentsLoadFailed = true
    });
  }
}
